import { BaseService } from '../../core/BaseService';
import { Wrapper } from '../../type';
import {
  BrandingRequest,
  ExportParamsRequest,
  ExportRequest,
  FileNameToBase64Request,
  GetBrandingResponse,
  ImportResponse,
  MarkFavouriteRequest,
  MultiActionsRequest,
  UploadRequest,
  UploadResponse,
} from './interface';

export class CommonProfile extends BaseService {
  async uploadEntity(req: UploadRequest) {
    const headers = { 'Content-Type': 'multipart/form-data' };

    const formData = new FormData();

    Object.entries(req).forEach(([key, value]) => {
      if (value !== null) {
        formData.append(key, value);
      }
    });

    return this.post<UploadResponse, FormData>(`${this.apiUrl}/api/${req.typeName}/upload`, formData, { headers });
  }

  async importEntity(req: unknown, typeName: string) {
    return this.post<ImportResponse, unknown>(`${this.apiUrl}/api/${typeName}/create/excel`, req);
  }

  async exportEntity(req: ExportRequest, type?: number) {
    return this.get<Blob>(`${this.apiUrl}/api/${req.typeName}${type ? '/' + type : ''}`, undefined, {
      responseType: 'blob',
    });
  }

  async exportEntityWithParams(req: ExportParamsRequest, typeName: string) {
    return this.get<Blob>(`${this.apiUrl}/api/${typeName}`, req, {
      responseType: 'blob',
    });
  }

  async getBrandingDetails(params: BrandingRequest) {
    return this.get<GetBrandingResponse>(`${this.apiUrl}/api/businesses/labeling`, params);
  }

  async markAsFavourite(req: MarkFavouriteRequest) {
    return this.put<Wrapper, MarkFavouriteRequest>(
      `${this.apiUrl}/api/${req.typeName}/${req.id}/favorite/${req.favorite}`,
      {}
    );
  }

  async deleteMedia(typeName: string, fileName: string, typeId: number) {
    return this.delete<Wrapper>(`${this.apiUrl}/api/${typeName}/${fileName}/type/${typeId}`);
  }

  async multiActions(req: MultiActionsRequest) {
    return this.post<Wrapper, MultiActionsRequest>(`${this.apiUrl}/api/${req.typeName}`, req);
  }

  async convertFilenameToBase64(req: FileNameToBase64Request) {
    const imageUrl = String(req?.imageUrl || "")
      .trim()
      .replace(/%27/gi, "")
      .replace(/%22/gi, "")
      .replace(/^['"]+|['"]+$/g, "")
      .trim();

    // Match Postman: GET /api/media/view?imageUrl=... with Accept: */*
    // Response body is a full data URL string (data:image/png;base64,...)
    return this.get<string>(
      `${this.apiUrl}/api/media/view`,
      { imageUrl },
      {
        headers: {
          Accept: "*/*",
        },
        responseType: "text",
      },
    );
  }
}
